import { BridgeComponent } from "@hotwired/hotwire-native-bridge"
import { resolveThemeColor } from "../../lib/bridge_colors"

// Button controller that supports separate light/dark theme colors
// Usage: data-bridge-light-color="#1a1a1a" data-bridge-dark-color="#e8e4df"
export default class extends BridgeComponent {
  static component = "button"

  connect() {
    super.connect()
    this.#updateButton()
    this.#observeDisabledChanges()
  }

  disconnect() {
    super.disconnect()
    this.#removeButton()
    this.observer?.disconnect()
  }

  #observeDisabledChanges() {
    this.observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.attributeName === "data-bridge-disabled") {
          this.#updateButton()
          break
        }
      }
    })
    this.observer.observe(this.element, { attributes: true })
  }

  #updateButton() {
    const element = this.bridgeElement
    const side = element.bridgeAttribute("side") || "right"
    const iosImage = element.bridgeAttribute("ios-image")
    const androidImage = element.bridgeAttribute("android-image")
    const disabled = element.bridgeAttribute("disabled") === "true"
    const color = resolveThemeColor(
      element.bridgeAttribute("light-color"),
      element.bridgeAttribute("dark-color")
    )

    const data = { title: element.title, iosImage, androidImage, color, disabled }

    this.send(side, data, () => {
      this.element.click()
    })
  }

  #removeButton() {
    this.send("disconnect")
  }
}
